// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__BiqRo","container":"Dashboard_container__VRI9f"};